export const ROLES = Object.freeze({
  ADMIN: 'Everest-Admin',
  CALL_CENTER_ADMIN: 'Everest-Call-Center-Admin',
  CANCEL_SAVE: 'Everest-Cancel-Save',
  CANCEL_SAVE_ADMIN: 'Everest-Cancel-Save-Admin',
  CLIENT_SERVICES: 'Everest-Client-Services',
  CLIENT_SERVICES_ADMIN: 'Everest-Client-Services-Admin',
  CORPORATE_BUCKET_ACCOUNT_CREATOR: 'Everest-Corporate-Bucket-Account-Creator',
  CORPORATE_MANAGER: 'Everest-Corporate-Manager',
  DEVELOPER: 'Everest-Developer',
  EVEREST: 'Everest',
  PRODUCT: 'Everest-Product',
  PRODUCT_ADMIN: 'Everest-Product-Admin',
  SALES: 'Everest-Sales',
  SALES_MANAGER: 'Everest-Sales-Manager',
  STAFF: 'Everest-Staff',
});
